module.exports = __webpack_public_path__ + "img/E9.cf39120a.svg";